exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-center[data-v-2ea1990c]{margin:auto;width:100%;padding:10px}.center a[data-v-2ea1990c]{margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}textarea[data-v-2ea1990c]{height:42px}.dev-priorities-ideas .cols-3[data-v-2ea1990c]{margin-right:10px}.cols-3 .cards-edit-box[data-v-2ea1990c]{width:calc(33% - 10px);margin-bottom:30px;margin-right:12px}.w33[data-v-2ea1990c]{width:calc(33% - 10px);margin-right:10px}.flex-start[data-v-2ea1990c]{justify-content:flex-start}", ""]);

// exports
